import { useCallback } from 'react';

import { translate } from 'services/localizationService';
import { localizationSelector } from 'store/localizationState';
import { useAppSelector } from './redux';

export function useTranslations(): (
  key: string,
  parameters?: Record<string, any>
) => string {
  const { translation } = useAppSelector(localizationSelector);

  // Translate
  return useCallback(
    (key: string, parameters?: Record<string, any>) =>
      translate(key, translation, parameters),
    [translation]
  );
}
